import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { RouterLink, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-landing-page',
  imports: [CommonModule, RouterLink, TranslocoPipe],
  templateUrl: './landing-page.html',
  styleUrl: './landing-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingPage implements OnInit {
  readonly route = inject(ActivatedRoute);

  alertMessage = signal<string>('');

  ngOnInit() {
    // Verifica se há mensagem nos query params
    this.route.queryParams.subscribe((params) => {
      if (params['message']) {
        this.alertMessage.set(params['message']);
      }
    });
  }

  closeAlert() {
    this.alertMessage.set('');
  }
}
